import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import addProduct from "../../assets/images/addProduct.png";
import {
  uploadImage,
  uploadProduct,
  uploadBlog,
  updateImage,
} from "../../firebase/firebase.utils";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { connect } from "react-redux";
import { ClipLoader } from "react-spinners";
import { getSingleBlogRedux } from "../../actions";
export class AddBlog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      skuId: "",
      inventory: "",
      name: "",
      price: "",
      salePrice: 0,

      pictures2: [addProduct],
      availability: "In-Stock",
      shortDetails: "",
      description: "",
      new: true,
      campaign: false,
      sale: true,
      colors: [],
      size: [],
      file: "",
      quantity: "",
      brand: "",
      productType: "simpleProduct",
      productOption: "General",
      stockStatus: "In stock",
      enableVariations: true,
      attribute: "",
      selectedAttributes: [],
      variations: "create",
      selectedVariations: [],
      videoUrl: "",
      checkedValues: [],
      checkedValues2: [],
      addCategory: false,
      addBrand: false,
      categoryName: "",
      parentCategory: "",
      mostUsedTags: false,
      editPublished: false,
      editVisibility: false,
      published: "Published",
      visibility: "Public",
      tag: "",
      showSuggestion: false,
      showSuggestion2: false,
      cursor: -1,
      selectedTags: [],
      newAttribute: "",
      attributes: [],
      savedAttributes: [],
      displayedVariations: [],
      termName: "",
      termSlug: "",
      termModalAttribute: null,
      variationPrice: "",
      brandName: "",
      parentBrand: "",
      selectedCampaign: "",
      loading: false,

      blogTitle: "",
      blogDescription: "",
      pictures: [addProduct],
    };
  }

  componentDidMount = async () => {
    if (this.props.match.params.id !== "add-blog") {
      await this.props.getSingleBlogRedux(this.props.match.params.id);
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.blog && this.props.blog !== nextProps.blog) {
      this.setState({
        blogTitle: nextProps.blog.blogTitle,
        blogDescription: nextProps.blog.blogDescription,
        pictures: nextProps.blog.pictures,
      });
    }

    console.log("component will receive props is getting called!");
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  _handleImgChange = (e, i) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      const pictures = [...this.state.pictures];
      pictures[i] = { preview: reader.result, file };
      this.setState({ pictures });
    };
    reader.readAsDataURL(file);
  };

  uploadImages = async (pictures) => {
    const urls = [];
    for (const pic of pictures) {
      console.log(pic.previousPictureUrl);
      if (
        pic?.file &&
        pic.previousPictureUrl &&
        pic.previousPictureUrl !== "/static/media/addProduct.3dff302b.png"
      ) {
        const url = await updateImage(
          pic.file,
          pic.previousPictureUrl,
          "Blogs",
        );
        urls.push(url);
      } else if (pic?.file) {
        const url = await uploadImage(pic.file, "Blogs");
        urls.push(url);
      } else {
        if (
          typeof pic == "string" &&
          pic !== "/static/media/addProduct.3dff302b.png"
        ) {
          urls.push(pic);
        }
      }
    }
    return urls;
  };

  handleFormSubmit = async () => {
    const { currentAdmin } = this.props;
    if (!currentAdmin) {
      alert("You are not registered admin to publish a blog post.");
      this.props.history.push("/");
      return;
    }
    if (
      !this.state.pictures[0] ||
      this.state.pictures[0] === addProduct ||
      this.state.pictures[0]?.preview === addProduct
    )
      return alert("Please upload at least one image for the product.");
    if (this.state.loading) {
      return;
    }

    const pictures = await this.uploadImages(this.state.pictures);

    const id = new Date().getTime().toString();
    let shouldExit = false;

    if (!this.state.blogTitle) return alert("You must provide a blog title.");
    if (!this.state.blogDescription)
      return alert("You must write something in blog description.");

    const currentDate = new Date();
    const datetime = `${currentDate.getDate()}/${
      currentDate.getMonth() + 1
    }/${currentDate.getFullYear()} at ${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    this.setState({
      loading: true,
    });
    const blog = await uploadBlog({
      id: this.props.blog ? this.props.blog.id : id,
      publishedOn: datetime,
      publishedBy: currentAdmin,
      blogTitle: this.state.blogTitle,
      blogDescription: this.state.blogDescription,
      pictures,
    });

    if (!blog) {
      this.setState({
        loading: false,
      });
      alert("Blog publised failed.try again");
      return;
    }

    toast.success("New blog is published");
    this.setState({
      loading: false,
    });
    this.setState({
      id: "",
      blogTitle: "",
      blogDescription: "",
      pictures: [addProduct],
    });
  };

  handleCkChange = (e, editor) => {
    let data = editor.getData();
    this.setState({
      blogDescription: data,
    });
  };

  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  clickActive2 = (event) => {
    document.querySelector(".nav-link2").classList.remove("show");
    event.target.classList.add("show");
  };

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState({
        checkedValues: this.state.checkedValues,
      });
    }
  };

  selectRow2 = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues2: this.state.checkedValues2.filter(
          (item, j) => i !== item,
        ),
      });
    } else {
      this.state.checkedValues2.push(i);
      this.setState({
        checkedValues2: this.state.checkedValues2,
      });
    }
  };

  render() {
    return (
      <Fragment>
        {this.state.loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <ClipLoader size={60} color="#36d7b7" />
          </div>
        )}
        <Breadcrumb title="Add Blog" parent="Blog Post" />

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row product-adding">
                    <div className="col" style={{ backgroundColor: "#f8f8f8" }}>
                      <div style={{ borderTop: "1px solid gainsboro" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            padding: "7px 20px",
                            paddingBottom: 0,
                            backgroundColor: "#f7f7f7",
                            marginTop: 5,
                          }}
                        >
                          <button
                            className="blue-bg-white"
                            style={{ marginLeft: 5, padding: "7px" }}
                            onClick={() => this.handleFormSubmit()}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                      <div id="accordion" className="accordion theme-accordion">
                        <div
                          className="card accordion-container"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            className="btn accordion-header-text"
                            data-toggle="collapse"
                            data-target="#collapseEleven"
                            aria-expanded="true"
                            aria-controls="collapseEleven"
                          >
                            <span>Blog Post Image</span>

                            <span>
                              <i className="icofont-rounded-up"></i>
                              <i className="icofont-rounded-down"></i>
                            </span>
                          </button>

                          <div
                            id="collapseEleven"
                            className="collapse show"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div style={{ padding: 20 }}>
                              <div
                                className="box-input-file"
                                style={{
                                  cursor: "pointer",
                                  maxHeight: 200,
                                  minHeight: 200,
                                  maxWidth: 200,
                                  minWidth: 200,
                                }}
                              >
                                <input
                                  className="upload"
                                  id="img-upload"
                                  type="file"
                                  onChange={(e) => this._handleImgChange(e, 0)}
                                  style={{
                                    position: "absolute",
                                    display: "none",
                                  }}
                                />

                                <img
                                  src={
                                    this.state.pictures[0]?.preview
                                      ? this.state.pictures[0].preview
                                      : this.state.pictures[0] // fallback for previously uploaded URL or placeholder
                                  }
                                  alt="product"
                                  className="img-fluid image_zoom_1 blur-up lazyloaded"
                                  style={{
                                    border: "1px solid gainsboro",
                                    borderRadius: 5,
                                  }}
                                  onClick={() => {
                                    window.document
                                      .getElementById("img-upload")
                                      .click();
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="accordion" className="accordion theme-accordion">
                        <div
                          className="card accordion-container"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            className="btn accordion-header-text"
                            data-toggle="collapse"
                            data-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            <span>Blog Title/Blog Headline </span>

                            <span>
                              <i className="icofont-rounded-up"></i>
                              <i className="icofont-rounded-down"></i>
                            </span>
                          </button>

                          <div
                            id="collapseOne"
                            className="collapse show"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div className="input-container-box">
                              <input
                                className="form-control"
                                name="blogTitle"
                                value={this.state.blogTitle}
                                type="text"
                                onChange={this.handleChange}
                                required
                                placeholder="Enter blog title or blog headline"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="accordion" className="accordion theme-accordion">
                        <div
                          className="card accordion-container"
                          style={{ marginTop: "20px" }}
                        >
                          <button
                            className="btn accordion-header-text"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="true"
                            aria-controls="collapseTwo"
                          >
                            <span>Blog Details/Blog Description</span>
                            <span>
                              <i className="icofont-rounded-up"></i>
                              <i className="icofont-rounded-down"></i>
                            </span>
                          </button>

                          <div
                            id="collapseTwo"
                            className="collapse show"
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div className="input-container-box">
                              <CKEditor
                                editor={ClassicEditor}
                                data={this.state.blogDescription}
                                onChange={this.handleCkChange}
                                config={{
                                  simpleUpload: {
                                    uploadUrl:
                                      "https://chinatrade.com.bd/image-upload",
                                  },
                                  toolbar: [
                                    "heading",
                                    "|",
                                    "bold",
                                    "italic",
                                    "blockQuote",
                                    "link",
                                    "numberedList",
                                    "bulletedList",
                                    "imageUpload",
                                    "insertTable",
                                    "tableColumn",
                                    "tableRow",
                                    "mergeTableCells",
                                    "mediaEmbed",
                                    "|",
                                    "undo",
                                    "redo",
                                  ],
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blog: state.blogs.blogObj,
    currentAdmin: state.admins.currentAdmin,
  };
};
export default connect(mapStateToProps, {
  getSingleBlogRedux,
})(AddBlog);
